var React = require('react');

function ArrowStraight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 17.5C2.067 17.5 0.5 19.067 0.5 21C0.5 22.933 2.067 24.5 4 24.5V17.5ZM417 21L382 0.79274V41.2073L417 21ZM4 24.5H385.5V17.5H4V24.5Z","fill":"#4D6888"}));
}

ArrowStraight.defaultProps = {"width":"417","height":"42","viewBox":"0 0 417 42","fill":"none"};

module.exports = ArrowStraight;

ArrowStraight.default = ArrowStraight;
